import { useEffect, useState } from "react";
import { CheckCircle2, AlertTriangle, CircleDashed } from "lucide-react";
import api from "../lib/api";

const Row = ({ id, name, ok, warn, label, hint }) => (
  <div className="flex items-start gap-2 text-xs" data-testid={`readiness-${id}`}>
    {ok ? <CheckCircle2 size={14} className="text-green-700 mt-0.5 shrink-0" /> : warn ? <AlertTriangle size={14} className="text-[#7a5a0f] mt-0.5 shrink-0" /> : <CircleDashed size={14} className="text-[#0a0d12]/40 mt-0.5 shrink-0" />}
    <div><span className="font-semibold">{name}</span> · <span data-testid={`readiness-${id}-label`}>{label}</span>{hint && <div className="text-[#0a0d12]/55">{hint}</div>}</div>
  </div>
);

// Staff-only go-live checklist for payment providers (reads backend .env state, never the secrets themselves).
export default function PaymentsReadiness() {
  const [r, setR] = useState(null);
  useEffect(() => { api.get("/admin/payments/readiness").then((x) => setR(x.data)).catch(() => setR(false)); }, []);
  if (r === null || r === false) return null;
  const { stripe, paystack, bank } = r;
  const allLive = stripe.live && paystack.enabled;
  return (
    <div className={`rounded-xl border p-4 mb-6 grid sm:grid-cols-3 gap-3 ${allLive ? "bg-green-50 border-green-200" : "bg-[#f8f4e8] border-[#d6aa43]/40"}`} data-testid="payments-readiness">
      <Row id="stripe" name="Stripe (cards, GBP/USD)" ok={stripe.live} warn={stripe.configured} label={stripe.mode}
        hint={stripe.live ? "Live gifts settle to the Foundation's Stripe account." : "Add your sk_live_ key as STRIPE_API_KEY in the backend secrets to go live."} />
      <Row id="paystack" name="Paystack (Book Store cards)" ok={paystack.enabled} warn={paystack.live_key && !paystack.activated}
        label={!paystack.live_key ? "test keys" : paystack.activated ? "live · active" : "live keys saved · hidden until activation"}
        hint={!paystack.live_key ? "Card payments hidden on the Book Store until live keys (sk_live_/pk_live_) are added." : paystack.activated ? "Card payments visible on the Book Store checkout." : "Set PAYSTACK_LIVE_ACTIVE=true once Paystack has activated the business account."} />
      <Row id="bank" name="Naira bank transfer" ok={bank.configured} label={bank.configured ? `${bank.bank_name} ${bank.account}` : "no account set"} hint={bank.account_name} />
    </div>
  );
}
